import { Run } from '@bringg/types';
import { getRoot } from 'mobx-easy';

import RootStore from 'bringg-web/stores/root-store';

export const fetchPlannedRoutes = async (routes: Run[], options?: { signal?: AbortSignal }) => {
	const plannedRouteIds = [...new Set(routes.filter(r => !!r.planned_route_id).map(r => r.planned_route_id))];

	const idsToFetch = plannedRouteIds.reduce((acc, plannedRouteId) => {
		if (!getRoot<RootStore>().data.plannedRoutesStore.get(plannedRouteId)) {
			acc.push(plannedRouteId);
		}
		return acc;
	}, []);

	await getRoot<RootStore>().data.plannedRoutesStore.batchGet(idsToFetch, options);
};
